export default __webpack_public_path__ + "static/media/arrow-right.556f45cc.svg";